import { useState } from "react";
import { ShareAltOutlined } from "@ant-design/icons";
import { Button } from "antd";
import PopUp from "../../shared-ui-components/PopUp";
import { ReactComponent as CopyIcon } from "../../assets/icons/copy.svg";
import { trackReportShare } from "../../analytics";

interface ShareButtonProps {
  analysisId: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({ analysisId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [shareUrl, setShareUrl] = useState("");
  const [copyMessage, setCopyMessage] = useState("");

  const handleOpen = () => {
    setShareUrl(window.location.href);
    trackReportShare(analysisId);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setCopyMessage("");
  };

  const copyToClipboard = () => {
    const textarea = document.createElement("textarea");
    textarea.value = shareUrl;
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      setCopyMessage("Link copied to clipboard!");
    } catch {
      setCopyMessage("Failed to copy link.");
    }
    document.body.removeChild(textarea);
  };

  return (
    <>
      <Button
        type="default"
        onClick={handleOpen}
        icon={<ShareAltOutlined />}
        className="share-button"
      />
      <PopUp openModal={isOpen} setOpenModal={handleClose} fullWidth={0}>
        <h3 className="link-copied">Share this Report!</h3>
        <input className="share-input" type="text" value={shareUrl} readOnly />
        <Button
          className="copy-button"
          onClick={copyToClipboard}
          icon={<CopyIcon />}
        />
        {copyMessage && <p className="copy-message">{copyMessage}</p>}
      </PopUp>
    </>
  );
};

export default ShareButton;
